import E3Widget from '@src/modules/performance/components/dashboard-widgets/E3Widget';
import ActivityManagementWidget from '@src/modules/performance/components/dashboard-widgets/ActivityManagementWidget';
import DeliveryWidget from '@src/modules/performance/components/dashboard-widgets/DeliveryWidget';
import DeliveryPerformanceWidget from '@src/modules/performance/components/dashboard-widgets/DeliveryPerformanceWidget';
import AmenityWidget from '@src/modules/performance/components/dashboard-widgets/AmenityWidget';
import SafetyWidget from '@src/modules/performance/components/dashboard-widgets/SafetyWidget';
import NetworkPhysicalCharacteristicsWidget from '@src/modules/performance/components/dashboard-widgets/NetworkPhysicalCharacteristicsWidget';
import RoadNetworkUseWidget from '@src/modules/performance/components/dashboard-widgets/RoadNetworkUseWidget';
import NetworkAvailabilityAccessibilityWidget from '@src/modules/performance/components/dashboard-widgets/NetworkAvailabilityAccessibilityWidget';
import PublicTransportWidget from '@src/modules/performance/components/dashboard-widgets/PublicTransportWidget';
import TerritorialActivityWidget from '@src/modules/performance/components/dashboard-widgets/TerritorialActivityWidget';
import ServicePerformanceWidget from '@src/modules/performance/components/dashboard-widgets/ServicePerformanceWidget';
import CoinvestorAssuranceWidget from '@src/modules/performance/components/dashboard-widgets/CoinvestorAssuranceWidget';
import TemporaryTrafficManagementWidget from '@src/modules/performance/components/dashboard-widgets/TemporaryTrafficManagementWidget';
import NetworkAssetManagementWidget from '@src/modules/performance/components/dashboard-widgets/NetworkAssetManagementWidget';
import PotholeRepairsWidget from '../components/dashboard-widgets/PotholeRepairsWidget';
import DataQualityWidget from '../components/dashboard-widgets/DataQualityWidget';

const widgetsMap = {
  activityManagement: ActivityManagementWidget,
  delivery: DeliveryWidget,
  deliveryPerformance: DeliveryPerformanceWidget,
  amenityAndCondition: AmenityWidget,
  safety: SafetyWidget,
  networkPhysicalCharacteristics: NetworkPhysicalCharacteristicsWidget,
  roadNetworkUse: RoadNetworkUseWidget,
  networkAvailability: NetworkAvailabilityAccessibilityWidget,
  publicTransport: PublicTransportWidget,
  territorialActivity: TerritorialActivityWidget,
  servicePerformance: ServicePerformanceWidget,
  coinvestorAssurance: CoinvestorAssuranceWidget,
  temporaryTrafficManagement: TemporaryTrafficManagementWidget,
  efficiencyEffectivenessEconomy: E3Widget,
  networkAssetManagement: NetworkAssetManagementWidget,
  potholeRepairs: PotholeRepairsWidget,
  dataQuality: DataQualityWidget,
};

export default widgetsMap;
